import React, { useState } from "react";
import { Link } from "react-router-dom";
import { auth } from "../firebase";
import { requestAccountDeletion } from "../services/accountService";

export default function DeleteAccount() {
  const [state, setState] = useState("idle");
  const user = auth.currentUser;
  const requestDeletion = async () => {
    if (!user) return;
    if (!window.confirm("Confirmar solicitação de exclusão da conta Zuno e dos dados pessoais associados?")) return;
    setState("loading");
    try { await requestAccountDeletion(); setState("done"); }
    catch (_) { setState("error"); }
  };
  return <main style={{ minHeight:"100vh", background:"#050816", color:"#fff", display:"grid", placeItems:"center", padding:24 }}>
    <section style={{ maxWidth:620, background:"#0c1430", border:"1px solid #24345d", borderRadius:24, padding:32 }}>
      <h1>Exclusão da conta Zuno</h1>
      <p>Você pode solicitar a exclusão da conta e dos dados pessoais pelo aplicativo ou por esta página. Registros financeiros ou de segurança serão apenas minimizados e retidos quando uma obrigação legal exigir.</p>
      <p>A solicitação remove acesso, notificações, localização ativa, cartões tokenizados, perfil e documentos. Corridas e pagamentos sujeitos a retenção ficam pseudonimizados.</p>
      {state === "done" ? <p style={{ color:"#4ade80" }}>Solicitação registrada. Sua sessão será encerrada e o atendimento concluirá a eliminação aplicável.</p>
        : user ? <button onClick={requestDeletion} disabled={state === "loading"} style={{ padding:"13px 18px", border:0, borderRadius:12, background:"#dc2626", color:"white", fontWeight:700 }}>{state === "loading" ? "Solicitando…" : "Solicitar exclusão da minha conta"}</button>
        : <p><Link to="/login?returnTo=/excluir-conta" style={{ color:"#67e8f9" }}>Entre na sua conta Zuno</Link> para confirmar a solicitação com segurança.</p>}
      {state === "error" && <p style={{ color:"#fca5a5" }}>Não foi possível registrar agora. Verifique se há uma corrida ativa e tente novamente.</p>}
      <p style={{ marginTop:24, fontSize:13, color:"#a8b4d3" }}>Contato de privacidade: privacidade@zunomovel.com.br</p>
    </section>
  </main>;
}
